import { constants } from 'lib_ui-services';

export default {
    verb: 'willEdit',
    namespace: 'metadata',
    relation: 'page',
    description: 'Assure record exists before editing',
    prerequisites: [
        {
            context: {
                verb: 'get',
                namespace: 'metadata',
                relation: 'page',
                type: 'find'
            },
            query: ({ data }) => {
                return {
                    _id: data._id,
                    'meta.deleted': { $exists: false }
                };
            }
        }
    ],
    //this is the actual logic:
    logic: willEdit
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function willEdit({ data, prerequisiteResults, context, dispatch }) {
    if (prerequisiteResults[0].result.length) {
        return;
    }

    const { namespace, relation } = context;
    const response = await dispatch(
        { query: { _id: data['metadata:useCaseDetail']._id, 'meta.deleted': { $exists: false } } },
        { verb: 'get', namespace, relation: 'useCaseDetail', type: 'find' },
        true
    );
    const version = response.result[0];
    if (!version)
        return rejectEdit('This version could not be found. Reload Metadata Creator before editing.', dispatch);
    // Older menus may have entries whose page was never created. Command mode
    // requires adding the page with navigation, before the editor opens it.
    if (version.authoringMode === 'commands') {
        return rejectEdit(
            'This menu entry has no saved page. Remove and re-add this menu entry before editing it.',
            dispatch
        );
    }

    const newRecord = {
        _id: data._id,
        title: data.title,
        isNavigationLink: true,
        'metadata:useCaseDetail': data['metadata:useCaseDetail'],
        blockly: {
            blocks: {
                languageVersion: 0,
                blocks: [
                    {
                        x: 50,
                        y: 70,
                        fields: { title: data.title },
                        type: 'page_NavigationLink'
                    }
                ]
            }
        }
    };
    await dispatch({ newRecord }, { verb: 'create', namespace, relation }, true);
}

async function rejectEdit(message, dispatch) {
    // Menu selection publishes an edit without awaiting it. Show the recovery
    // message explicitly because its failure event does not display a toast.
    await dispatch(
        { message, timeout: 5000, addToList: false, variant: 'error', type: constants.notificationTypes.TOAST },
        { verb: 'pop', namespace: 'application', relation: 'notification' }
    );
    throw new Error(message);
}
